import * as React from "react";
import AbstractLookup, { LookupConfigInterface } from "./AbstractLookup";
import { LookupInterface } from "./LookupInterface";
import * as onClickOutside from "react-onclickoutside";
import Translator from "../../../Translation/Translator";
import Constants from "../../../Action/Constants";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

class PropertyLookup extends AbstractLookup implements LookupInterface {

  protected componentRef: any;
  protected config: LookupConfigInterface = {
    entities: Object.keys(this.props.properties?.byId || {}).map((id) => this.props.properties?.byId[id]),
    type: Constants.LOOKUP_COMPONENT_PROPERTY_CREATE_START,
    payloadPrefix: "property",
    entityTranslation: Translator.trans("label-property"),
    disableEntityCreation: this.props.disableEntityCreation || false,
    floatingLabelText: this.props.floatingLabelText || Translator.trans("dropdown-searchforproperty-label"),
    labelText: Translator.trans("dropdown-property-label"),
    buttonLabel: this.props.buttonLabel || Translator.trans("dropdown-button-new-property"),
    dialogTitle: this.props.dialogTitle || Translator.trans("dropdown-button-new-property"),
    dialogType: this.props.dialogType || Constants.LOOKUP_COMPONENT_DIALOG_TYPE_SMALL,
    visibilityProperty: "displayName",
    dialogInputToComponentSyncProperty: "displayName",
    componentState: {
      address: ""
    },
    filter: this.props.filter || false,
    createPage: "/app/property/create",
    linkedObjectUrl: "/app/property/update/",
    noResultText: this.props.noResultText || this.trans("dropdown-property-notfound")
  };

  constructor(public props) {
    super(props);
  }

  public syncDialogValue(value: string): any {
    this.config.componentState.address = value;
    this.setState({
      address: value
    });
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public propertyComparer = (a, b) => {
    return this.comparer(a.address.locality, b.address.locality) ||
      this.comparer(a.address.route, b.address.route) ||
        this.comparer(a.address.formattedAddress, b.address.formattedAddress);
  }

  public getList(): any[] {
    let list: PropertyInterface[] = this.getEntities()
      .filter((property: PropertyInterface) => {
        return property.address.formattedAddress.toLowerCase().includes(String(this.state.searchText).toLowerCase());
      })
      .sort(this.propertyComparer);

    return list.map((property: PropertyInterface, index: number) => {
      return (
        <ListItem
          key={index}
          onMouseDown={this.onSelect.bind(this, property)}
        >
          <ListItemAvatar>
            <Avatar className="avatar">
              {property.renderAvatar()}
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary={property.address && property.address.formattedAddress}
          />
        </ListItem>
      );
    });
  }

  public getEntities(): PropertyInterface[] {
    if (Array.isArray(this.props.entitiesToSearch)) {
      return this.props.entitiesToSearch;
    } else {
      return Object.keys(this.props.properties?.byId || {}).map((id) => this.props.properties.byId[id])
        .filter(property => !!property)
        .filter(property => {
          if (Array.isArray(this.props.filterOutPropertyIds) && property?.id && this.props.filterOutPropertyIds.includes(property?.id)) {
            return false;
          } else if (this.props.onlyPropertyRelatedOwner) {
            return this.props.onlyPropertyRelatedOwner?.id === property?.companyId;
          } else {
            return !!property;
          }
        })
        .filter((property: PropertyInterface) => {
          return property.removed === false || (property.removed === true && !!this.props.autoSelectId && property.id === this.props.autoSelectId);
        })
        .filter((property: PropertyInterface) => {
          if (this.props.filterMainPropertyOnMovingUnit) {
            return property?.id !== this.props.filterMainPropertyOnMovingUnit
          } else {
            return property;
          }
        })
    }
  }

  public getPayloadFromComponent(): any {
    return {};
  }
}

export default onClickOutside(PropertyLookup);
